export const SIDE_MENU_WIDTH = 240
export const SIDE_MENU_DURATION = 0.5
export const DRAWER_WIDTH_CLOSED = 65
export const MIN_WIDTH_PAGE_CONTAINER = 575
export const MID_WIDTH_PAGE_CONTAINER = 1000
export const HEADER_HEIGHT = 64
